<script>
import { mapActions, mapState } from "vuex";

import documentMixin from "@/mixins/documentMixin";

export default {
  mixins: [documentMixin],
  data() {
    return {
      UploadDocLoader: false,
      loader: false,
      paths: {},
      content: {
        cpf: "",
        name: "",
        rgIssuingAuthority: "",
        rgIssueState: "",
        issueDate: ""
      },
      ocrDocumentType: [
        { text: "Selfie", value: "SELFIE" },
        { text: "Carteira Nacional de Habilitação", value: "CNH" },
        { text: "Carteira de Identidade", value: "RG" },
        { text: "Registro nacional de estrangeiros", value: "RNE" }
      ]
    };
  },
  computed: {
    ...mapState("newDocument", ["document_type"]),

    isSelfie: function() {
      return this.document_type === "SELFIE";
    }
  },
  methods: {
    ...mapActions("newDocument", [
      "setPaths",
      "setApproved",
      "setDocumentType",
      "setContent",
      "setExternalId",
      "createDocument"
    ]),
    ...mapActions("documents", ["sendDocumentImage"]),
    setValueToContent(value, key) {
      this.content[key] = value;
    },

    async dispatchDocument() {
      this.loader = true;
      this.setContent(this.content);
      await this.createDocument(this.professional.account);
      this.loader = false;
      this.closeDialog();
    },

    async submitUploadDocumentPicture(file, type) {
      this.UploadDocLoader = true;

      let data = new FormData();

      data.append("upload_preset", "documents");

      data.append("file", file);

      try {
        let picture = await this.sendDocumentImage(data);

        this.paths[type] = picture;
        this.setPaths(this.paths);
      } catch (e) {
        this.$toast.error(e);
      }

      this.UploadDocLoader = false;
    },

    closeDialog() {
      this.$emit("close");
      this.$emit("refresh");
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    professional: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card class="content">
      <v-card-title>
        <span class="headline text-uppercase font-weight-medium">
          Criar Documento
        </span>
        <v-spacer></v-spacer>
        <v-btn color="accent" rounded icon outlined @click="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-layout column>
        <v-select
          required
          autofocus
          label="Selecione o tipo de documento"
          prepend-inner-icon="mdi-file-document"
          :items="ocrDocumentType"
          @input="setDocumentType"
        />
        <div v-if="!isSelfie">
          <v-text-field
            name="rg"
            label="Numero registro"
            @input="setValueToContent($event, 'rg')"
            v-validate="'numeric'"
            :error-messages="errors.first('rg')"
            :error="errors.has('rg')"
          />

          <v-text-field
            name="rgIssuingAuthority"
            label="Orgao emissor"
            @input="setValueToContent($event, 'rgIssuingAuthority')"
            v-validate="'required|alpha_spaces'"
            :error-messages="errors.first('rgIssuingAuthority')"
            :error="errors.has('rgIssuingAuthority')"
          />

          <v-text-field
            name="rgIssueState"
            label="Estado emissor"
            @input="setValueToContent($event, 'rgIssueState')"
            v-validate="'required|alpha_spaces'"
            :error-messages="errors.first('rgIssueState')"
            :error="errors.has('rgIssueState')"
          />

          <v-text-field
            v-mask="'##/##/####'"
            return-masked-value
            name="issueDate"
            label="Data de expedicao"
            @input="setValueToContent($event, 'issueDate')"
            :error-messages="errors.first('issueDate')"
            :error="errors.has('rgIssuingDate')"
          />

          <v-text-field
            v-mask="'###.###.###-##'"
            return-masked-value
            name="cpf"
            label="CPF"
            @input="setValueToContent($event, 'cpf')"
            :error-messages="errors.first('cpf')"
            :error="errors.has('cpf')"
          />

          <v-text-field
            name="name"
            label="Nome"
            @input="setValueToContent($event, 'name')"
            v-validate="'required|alpha_spaces'"
            :error-messages="errors.first('name')"
            :error="errors.has('name')"
          />
        </div>
        <div>
          <v-file-input
            v-if="isSelfie"
            label="Inserir Selfie"
            filled
            prepend-icon="mdi-camera"
            @change="submitUploadDocumentPicture($event, 'selfie')"
          ></v-file-input>

          <v-file-input
            v-if="!isSelfie"
            label="Inserir frente do documento"
            filled
            prepend-icon="mdi-camera"
            @change="submitUploadDocumentPicture($event, 'front')"
          ></v-file-input>

          <v-file-input
            v-if="!isSelfie"
            label="Inserir verso do documento"
            filled
            dense
            prepend-icon="mdi-camera"
            @change="submitUploadDocumentPicture($event, 'back')"
          ></v-file-input>
          <v-btn
            color="primary"
            small
            :disabled="UploadDocLoader"
            :loading="loader"
            djfdhfksd
            @click="dispatchDocument()"
          >
            <span>Criar documento</span>
          </v-btn>
        </div>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
.content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Documents/NewDocument/Index.vue